import React from 'react';
import MuiTypography from '@material-ui/core/Typography';

const Typography = props => <MuiTypography {...props} />;

Typography.muiName = 'Typography';

export default Typography;
